module.exports = __webpack_public_path__ + "static/img/kongtiao-zidong-active.d31968ef.png";